import { LockSimple } from "@phosphor-icons/react";

const pct = (v) => (v == null ? "—" : `${Math.round(v * 100)}%`);
const VERDICT = {
  pass: { label: "PASS", color: "#10B981" },
  fail: { label: "FAIL", color: "#EF4444" },
  inconclusive: { label: "INCONCLUSIVE", color: "#F59E0B" },
  incomplete: { label: "INCOMPLETE", color: "var(--o-muted2)" },
};

const Metric = ({ label, value, hint, testid }) => (
  <div className="py-3 border-b border-[var(--o-border-soft)]">
    <div className="flex justify-between items-baseline">
      <span className="text-xs text-[var(--o-muted)]">{label}</span>
      <span className="font-mono text-sm" data-testid={testid}>{value}</span>
    </div>
    {hint && <p className="font-mono text-[10px] text-[var(--o-muted3)] mt-1">{hint}</p>}
  </div>
);

const Progress = ({ name, done, total }) => (
  <div className="space-y-1.5">
    <div className="flex justify-between text-xs"><span>{name}</span><span className="font-mono text-[var(--o-muted)]">{done}/{total}</span></div>
    <div className="h-1 bg-[var(--o-border)]"><div className="h-full bg-[var(--o-fg)] transition-[width] duration-500" style={{ width: `${total ? (done / total) * 100 : 0}%` }} /></div>
  </div>
);

export const ResultsPanel = ({ summary, scorers, reveal, onReveal }) => {
  const v = VERDICT[summary.verdict];
  const locked = !reveal;
  return (
    <div className="border border-[var(--o-border)] p-5 space-y-5 bg-[var(--o-bg2)]" data-testid="scoring-results">
      <div className="space-y-3">
        <Progress name={scorers.a.name} done={summary.progress.a} total={summary.items} />
        <Progress name={scorers.b.name} done={summary.progress.b} total={summary.items} />
      </div>
      {locked ? (
        <div className="border border-dashed border-[var(--o-border-strong)] p-4 text-center space-y-3" data-testid="results-locked">
          <LockSimple size={20} className="mx-auto text-[var(--o-muted2)]" />
          <p className="text-xs text-[var(--o-muted)]">Scoring is blind. Results unlock when both scorers have rated every item.</p>
          <button onClick={onReveal} className="font-mono text-[11px] text-[var(--o-muted2)] underline hover:text-[var(--o-fg)]" data-testid="reveal-anyway-button">Reveal anyway</button>
        </div>
      ) : (
        <div>
          <div className="flex items-center justify-between pb-3">
            <span className="font-display text-lg font-bold">Verdict</span>
            <span className="font-mono text-xs px-2 py-1 border" style={{ color: v.color, borderColor: v.color }} data-testid="scoring-verdict">{v.label}</span>
          </div>
          <Metric label="Scorer agreement" value={pct(summary.agreement)} hint="pass ≥ 67% · items where both gave the same score" testid="metric-agreement" />
          <Metric label="Answers scored 3 by both" value={pct(summary.answers_both_3_rate)} hint="pass ≥ 50% · fail < 33%" testid="metric-both3" />
          <Metric label={`${scorers.a.name} · share of 3s`} value={pct(summary.share_3.a)} />
          <Metric label={`${scorers.b.name} · share of 3s`} value={pct(summary.share_3.b)} />
          <Metric label="Flags judged generic" value={pct(summary.flag_generic_rate)} hint="dry-run target < 33%" testid="metric-flag-generic" />
        </div>
      )}
    </div>
  );
};
